import { ScrollView, StyleSheet } from "react-native";
import { useTranslation } from "react-i18next";
import { toSupportedLng } from "@heraion/i18n";
import { LanguageRegionPanel, resolveTheme, type UiTheme } from "@heraion/ui";
import { useThemePalette } from "./theme";

// Settings -> Language & region on the web console (#390): the app language
// and the date format, the same panel as mobile. The language drives
// react-i18next directly and the detector persists it to localStorage; the
// date format is kept by the DateFormatProvider main.tsx mounts.
export function LanguageRegionScreen() {
  const { dark, family } = useThemePalette();
  const theme = resolveTheme(dark, family);
  const { i18n } = useTranslation();
  const styles = makeStyles(theme);
  return (
    <ScrollView style={styles.flex} contentContainerStyle={styles.body}>
      <LanguageRegionPanel
        theme={theme}
        language={toSupportedLng(i18n.language)}
        onPickLanguage={(lng) => void i18n.changeLanguage(lng)}
      />
    </ScrollView>
  );
}

function makeStyles(theme: UiTheme) {
  const { palette: p, spacing: s } = theme;
  return StyleSheet.create({
    flex: { flex: 1, backgroundColor: p.bg },
    body: { paddingHorizontal: s.s5, paddingVertical: s.s4 },
  });
}
